import styled from 'styled-components';

import { Colors } from 'styles/enums';

export const ImageGalleryWrapper = styled.div`
  padding: 20px;
`;

export const SelectedImageContainer = styled.div`
  box-shadow: -10px 10px ${Colors.Turkish.base100};
`;

export const MinifiedImageContainer = styled.div`
  width: 100%;
  min-height: 145px;
`;
